export default __webpack_public_path__ + "static/media/confirmation1.49e1b98e.jpg";